import { render, staticRenderFns } from "./DialogEnviarElementosExtraviados.vue?vue&type=template&id=62c499e9&scoped=true"
import script from "./DialogEnviarElementosExtraviados.vue?vue&type=script&lang=js"
export * from "./DialogEnviarElementosExtraviados.vue?vue&type=script&lang=js"
import style0 from "./DialogEnviarElementosExtraviados.vue?vue&type=style&index=0&id=62c499e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c499e9",
  null
  
)

export default component.exports